document.querySelectorAll('.product_facts_container').forEach(item => {
    item.querySelector('.facts_button').addEventListener('click', () => {
        item.classList.toggle('active')
    })
})